<template>
  <div class="mt-2">
    <v-card flat outlined>
      <v-card-title class="subtitle-1 font-weight-bold"
        >Choose a package</v-card-title
      >
      <v-card-text>
        <v-chip-group
          v-model="selectedBundle"
          :color="$buttonColor"
          @change="onChoose"
          :column="$vuetify.breakpoint.smAndDown"
        >
          <template v-for="(bundle, idx) of bundlesItems">
            <v-tooltip bottom :key="`bundle_${idx}`">
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  :color="selectedId == bundle._id ? $buttonColor : ''"
                  large
                  :value="bundle"
                  label
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  filter
                  filter-icon="far fa-check"
                >
                  {{ bundle.title }}
                </v-chip>
              </template>
              <span>{{
                bundle.description == "" || bundle.description == null
                  ? bundle.title
                  : bundle.description
              }}</span>
            </v-tooltip>
          </template>
        </v-chip-group>
      </v-card-text>
      <!-- <div class="d-flex align-center">
        <div class="flex-grow-1">
          <v-card-title>{{ bundle.title }}</v-card-title>
          <v-card-subtitle>{{ bundle.description }}</v-card-subtitle>
        </div>
      </div> -->
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    bundles: {
      type: Array,
      required: true,
      default: [],
    },
    showAsBottomSheet: {
      type: Boolean,
      default: false,
    },
    courseTitle: {
      type: String,
      required: false,
      default: "",
    },
  },
  data: () => ({
    sheet: false,
    selectedBundle: null,
  }),
  computed: {
    selectedId() {
      if (this.selectedBundle == null) {
        return null;
      } else {
        return this.selectedBundle._id;
      }
    },
    bundlesItems() {
      function comparer(a, b) {
        if (a.price < b.price) {
          return -1;
        }
        if (a.price > b.price) {
          return 1;
        }
        return 0;
      }

      return this.bundles.sort(comparer);
    },
    buttonColor() {
      let color =
        this.$userInfo.companies[0].buttonColor ||
        Vue.prototype.$userInfo.companies[0].buttonColor;

      return color;
    },
  },
  methods: {
    onChoose() {
      //   if (this.showAsBottomSheet) {
      //     this.sheet = false;
      //   }
      this.$emit("onChoose", this.selectedBundle || null);
    },
  },
};
</script>

<style scoped>
.selected-bundle {
  background-color: #444;
  height: 20px;
  left: -10px;
  position: absolute;
  top: -10px;
  width: 10px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
}
/* ::v-deep .v-chip__content {
  position: relative;
} */
</style>